import RequestPasswordConfirmation from './RequestPasswordConfirmation';

export default RequestPasswordConfirmation;
